import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ShellComponent } from './shared/components/shell/shell.component';

export const appRoutes: Routes = [
  // Ruta raíz → redirige al dashboard
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // Auth (sin shell, sin guard)
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },

  // Shell protegido con authGuard
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        title: 'Dashboard — Zentrix v1'
      },
      {
        path: 'pre-validacion',
        loadComponent: () =>
          import('./features/pre-validacion/pre-validacion.component').then(m => m.PreValidacionComponent),
        title: 'Pre-validación — Zentrix v1'
      },
      {
        path: 'motor',
        loadComponent: () =>
          import('./features/motor/motor.component').then(m => m.MotorComponent),
        title: 'Motor — Zentrix v1'
      },
      {
        path: 'motor-maduracion',
        loadComponent: () =>
          import('./features/motor-maduracion/motor-maduracion.component').then(m => m.MotorMaduracionComponent),
        title: 'Motor de Maduración — Zentrix v1'
      },
      {
        path: 'templates',
        loadComponent: () =>
          import('./features/templates/templates.component').then(m => m.TemplatesComponent),
        title: 'Templates — Zentrix v1'
      },
      {
        path: 'extraccion',
        loadComponent: () =>
          import('./features/extraccion/extraccion.component').then(m => m.ExtraccionComponent),
        title: 'Reporte de chips — Zentrix v1'
      },
      {
        path: 'monitor',
        loadComponent: () =>
          import('./features/monitor/monitor.component').then(m => m.MonitorComponent),
        title: 'Monitor — Zentrix v1'
      },
      {
        path: 'usuarios',
        loadComponent: () =>
          import('./features/usuarios/usuarios.component').then(m => m.UsuariosComponent),
        title: 'Usuarios — Zentrix v1'
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./features/reportes/reportes.component').then(m => m.ReportesComponent),
        title: 'Reportes — Zentrix v1'
      },
      {
        path: 'campanas',
        loadComponent: () =>
          import('./features/campaign-dashboard/campaign-dashboard.component').then(m => m.CampaignDashboardComponent),
        title: 'Campañas — Zentrix v1'
      },
      {
        path: 'historial-envios',
        loadComponent: () =>
          import('./features/campaign-history/campaign-history.component').then(m => m.CampaignHistoryComponent),
        title: 'Historial de Envíos — Zentrix v1'
      }
    ]
  },

  // Fallback
  { path: '**', redirectTo: 'dashboard' }
];
